export default {
  props: {
    info: { type: Object },
    edit: { type: Boolean },
    comments: { type: Boolean },
    commentsThread: { type: Array },
    pdf: { type: Boolean },
    link: { type: Boolean },
    actionsPlacement: { type: String, default: 'top-start' }
  }
}
